import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  focusVisibleSelector
} from "./chunk.6JE2K3D5.js";
import {
  l
} from "./chunk.Z4OOI5NQ.js";
import {
  e,
  i2,
  n
} from "./chunk.5E26GMTR.js";
import {
  $,
  component_styles_default,
  r,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.FE67GRYM.js
var icon_button_styles_default = r` ${component_styles_default} :host { display: inline-block; } .icon-button { flex: 0 0 auto; display: flex; align-items: center; background: none; border: none; border-radius: var(--sl-border-radius-medium); font-size: inherit; color: var(--sl-color-neutral-600); padding: var(--sl-spacing-x-small); cursor: pointer; transition: var(--sl-transition-medium) color; -webkit-appearance: none; } .icon-button:hover:not(.icon-button--disabled), .icon-button:focus:not(.icon-button--disabled) { color: var(--sl-color-primary-600); } .icon-button:active:not(.icon-button--disabled) { color: var(--sl-color-primary-700); } .icon-button:focus { outline: none; } .icon-button--disabled { opacity: 0.5; cursor: not-allowed; } .icon-button${focusVisibleSelector} { box-shadow: var(--sl-focus-ring); } `;

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.BN5JWAGI.js
var SlIconButton = class extends s4 {
  constructor() {
    super(...arguments);
    this.label = "";
    this.disabled = false;
  }
  render() {
    const isLink = this.href ? true : false;
    const interior = $`<sl-icon name=${l(this.name)} library=${l(this.library)} src=${l(this.src)} aria-hidden="true" ></sl-icon>`;
    return isLink ? $`<a part="base" class="icon-button" href=${l(this.href)} target=${l(this.target)} download=${l(this.download)} rel=${l(this.target ? "noreferrer noopener" : void 0)} role="button" aria-disabled=${this.disabled ? "true" : "false"} aria-label="${this.label}" tabindex=${this.disabled ? "-1" : "0"} >${interior}</a>` : $`<button part="base" class=${o({
      "icon-button": true,
      "icon-button--disabled": this.disabled
    })} ?disabled=${this.disabled} type="button" aria-label=${this.label} >${interior}</button>`;
  }
};
SlIconButton.styles = icon_button_styles_default;
__decorateClass([
  i2(".icon-button")
], SlIconButton.prototype, "button", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "name", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "library", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "src", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "href", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "target", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "download", 2);
__decorateClass([
  e()
], SlIconButton.prototype, "label", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlIconButton.prototype, "disabled", 2);
SlIconButton = __decorateClass([
  n("sl-icon-button")
], SlIconButton);
